var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"jbsDropdownMenu",staticClass:"jbs-dropdown-menu"},[(this.$parent.showDropdown == true)?_c('div',[_c('ul',[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }